import { c as _c } from "react/compiler-runtime";
import { Spacer } from '@chakra-ui/react';
import { ComprehensiveHelpContent } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/content/ComprehensiveHelpContent';
import { PerfectCustomEmailsContent } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/content/PerfectCustomEmailsContent';
import { GenericBlock } from '@src/components/sco/LayoutBlocks/GenericBlock';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const PitchBlock = () => {
  const $ = _c(10);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      children: "Prepare Your Ideal Pitch"
    };
    t1 = {
      children: "Our Pitch Builder generates individualized emails to send to your matched investors."
    };
    t2 = <PerfectCustomEmailsContent />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== getBreakpointValue) {
    t3 = getBreakpointValue([10, 10, 10, 14, 20]);
    $[3] = getBreakpointValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Spacer marginY={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ComprehensiveHelpContent />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <GenericBlock background="backgroundSecondary" headingProps={t0} textProps={t1}>{t2}{t4}{t5}</GenericBlock>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};